import { Alert, SpinnerOverlay, Text } from '@quality24/design-system';
import * as React from 'react';

import { useAuth } from '../../contexts/auth/useAuth';

const OIDCSignInPage: React.FunctionComponent = () => {
  const { route, inProgress, error, setRoute } = useAuth();

  // Set initial page route
  React.useEffect(() => {
    if (!route) {
      setRoute('signIn');
    }
  }, [setRoute, route]);

  return (
    <>
      {error && (
        <Alert className="mb-3" variant="danger">
          {error}
        </Alert>
      )}
      {inProgress && <SpinnerOverlay size="sm" />}

      <div>
        <Text>Aguarde nesta tela enquanto te redirecionamos.</Text>
      </div>
    </>
  );
};

export default OIDCSignInPage;
